import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ContentPage } from 'common/content/page';
import { ExperimentPageProvider } from '../context';
import { storeMetricResults } from '../hooks/metric-results';
import { useQueryExperiment } from '../hooks/query-experiment';
import { ExperimentPageHeader } from './header';
import { ExperimentPageMain } from './main';
import { ExperimentPageConfiguration } from './configuration';
import { ExperimentPageSettingsModal } from './settings-modal';
type ExperimentPageProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
  experimentId: string;
};
export function ExperimentPage(_ref: ExperimentPageProps) {
  let {
    projectId,
    workspaceId,
    userId,
    experimentId
  }: ExperimentPageProps = _ref;
  const experimentState = useExperimentsStore(state => state.experimentState);
  const experimentLoading = useExperimentsStore(state => state.experimentLoading);
  useQueryExperiment({
    projectId,
    workspaceId,
    experimentId
  });
  storeMetricResults({
    projectId,
    workspaceId,
    experimentId
  });
  if (!experimentState || experimentLoading) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <ExperimentPageProvider projectId={projectId} workspaceId={workspaceId} experimentId={experimentId} userId={userId} data-sentry-element="ExperimentPageProvider" data-sentry-component="ExperimentPage" data-sentry-source-file="index.tsx">
      <ContentPage header={<ExperimentPageHeader />} data-sentry-element="ContentPage" data-sentry-source-file="index.tsx">
        <ExperimentPageMain data-sentry-element="ExperimentPageMain" data-sentry-source-file="index.tsx" />
        <ExperimentPageConfiguration data-sentry-element="ExperimentPageConfiguration" data-sentry-source-file="index.tsx" />
      </ContentPage>
      <ExperimentPageSettingsModal data-sentry-element="ExperimentPageSettingsModal" data-sentry-source-file="index.tsx" />
    </ExperimentPageProvider>;
}